import { Controller } from "@hotwired/stimulus"
import { Offcanvas } from 'bootstrap'

export default class extends Controller {
  static values = { open: String }

  connect() {
    if (this.openValue === 'true') {
      this.open()
    }

    // Listen for custom event to open offcanvas
    document.addEventListener('cart:open', this.handleOpen.bind(this))
  }

  disconnect() {
    document.removeEventListener('cart:open', this.handleOpen.bind(this))
  }

  handleOpen() {
    this.open()
  }

  open() {
    const offcanvas = Offcanvas.getOrCreateInstance(this.element)
    offcanvas.show()
  }
}

